export default __webpack_public_path__ + "static/media/logo.851b8840.png";